import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { FlightService } from 'src/app/_services/api/flight/flight.service';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { Language, ObjectLiteral } from 'src/app/_models/user';
import { SessionService } from 'src/app/_services/session/session.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ua-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('langIcon') langIcon: ElementRef;

  @Input() showBackButton: boolean = false;

  @Output('navigateBack') backButtonEmitter = new EventEmitter();

  @Input() hideLang: boolean = false;

  showFlightTicketDetails: boolean = false;
  flightTicketDetails: any = null;
  travelerDetails: any = null;
  badgeSrc = '';

  isLangModalOpen: boolean = false;
  commonConstants: ObjectLiteral;
  languageSubscription: Subscription;

  constructor(
    private logger: LoggerService,
    private flightService: FlightService,
    private languageService: LanguageService,
    private sessionService: SessionService
  ) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
      this.commonConstants = this.languageService.constants?.commons || {};
    });

    // hides the globe icon
    !this.hideLang && (this.hideLang = this.languageService.isBrowserDefaultLanguage());
  }

  ngOnInit() {
    this.showFlightTicketDetails = false;
    this.flightTicketDetails = this.flightService.flightDetails;
    this.travelerDetails = this.flightService.activeTraveler;
    if (this.flightTicketDetails && this.travelerDetails && (this.flightTicketDetails.confirmationID || this.travelerDetails.givenName)) {
      this.showFlightTicketDetails = true;
    }
    // this.formatBadgeSrc();
    this.logger.debug('HeaderComponent: ngOnInit()', this.travelerDetails);
  }

  formatBadgeSrc() {
    switch (this.travelerDetails.mpType) {
      case 'GOLD *G':
        this.badgeSrc = 'gold';
        break;
      default:
        this.badgeSrc = this.travelerDetails.mpType?.toLowerCase()
    }
    this.logger.debug('HeaderComponent: formatBadgeSrc', this.badgeSrc, this.travelerDetails?.mpType)
  }


  ngAfterViewInit() {
    this.checkLangPreference();
  }

  goBack() {
    this.backButtonEmitter.emit();
  }
  /* -------------- START :: Language options --------------- */

  checkLangPreference() {
    // opens the modal initially if no preferrence given already
    !this.isLangModalOpen && (this.isLangModalOpen = !this.sessionService.isLangPreferred);
  }

  selectedLanguage(selectedLang: Language) {
    this.closeLangModal();
    this.languageService.getConstants(selectedLang.locale);
  }

  closeLangModal() {
    this.isLangModalOpen = false;
  }

  openLangModel() {
    this.isLangModalOpen = true;
  }

  ngOnDestroy() {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }
  /* -------------- END :: Language options --------------- */

}
